import React, { useEffect, useState, Suspense, lazy } from 'react';
import Header from './jsx/layouts/Headers/Header';
// import Landing from './jsx/components/Customer/Landing/Landing';

import { BrowserRouter, Route, Link, Routes, Navigate } from 'react-router-dom';
import Footer from './jsx/layouts/Footer/Footer';
import Login from './jsx/components/Customer/Auth/Login';
import Register from './jsx/components/Customer/Auth/Register';
import ValidateRegister from './jsx/components/Customer/Auth/ValidateRegister';
import ScrollToTop from './ScrollToTop';
import About from './jsx/components/Customer/About/About';
import Shop from './jsx/components/Customer/Shop/Shop';
import ProductDetails from './jsx/components/Customer/Shop/ProductDetails';
import CartDetails from './jsx/components/Customer/Cart/CartDetails';
import Checkout from './jsx/components/Customer/Cart/Checkout';
import OrderSuccess from './jsx/components/Customer/Cart/OrderSuccess';
import { useSelector } from 'react-redux';
import ManageProducts from './jsx/components/Admin/Products/ManageProducts';
import OrderFailed from './jsx/components/Customer/Cart/OrderFailed';
import ContactUs from './jsx/components/Customer/ContactUs/ContactUs';
import OrderManagement from './jsx/components/Admin/Orders/OrderManagement';
import UpdateOrderDetails from './jsx/components/Admin/Orders/UpdateOrderDetails';
import Tooltip from '@mui/material/Tooltip';
import TermsAndConditions from './jsx/layouts/Footer/TermsAndConditions';
import PrivacyPolicy from './jsx/layouts/Footer/PrivacyPolicy';
import CancellationsAndRefunds from './jsx/layouts/Footer/CancellationsAndRefunds';
import Shipping from './jsx/layouts/Footer/Shipping';
import BlogList from './jsx/components/Customer/Blogs/BlogList';
import ManageBlogs from './jsx/components/Admin/Blogs/ManageBlogs';
import ManagePincodes from './jsx/components/Admin/Pincode/ManagePincodes';
import MyAccount from './jsx/components/Customer/Profile/MyAccount';
import BlogDetails from './jsx/components/Customer/Blogs/BlogDetails';
import AppLoader from './jsx/pages/AppLoader';

const App = () => {
  const user = useSelector(state => state?.auth?.user);

  const [isVisible, setIsVisible] = useState(false);

  // const handleScroll = () => {
  //   const currentScroll = window.scrollY;
  //   setIsVisible(currentScroll > 500);
  // };

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  // const scrollToTop = () => {
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  // };

  const Landing = lazy(() => import('./jsx/components/Customer/Landing/Landing'));

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<AppLoader />}>
          <Header />
          <Routes>
            <Route exact path='/' element={<Landing />} />
            <Route exact path='/login' element={<Login />} />
            <Route exact path='/register' element={<Register />} />
            <Route exact path='/verify/account' element={<ValidateRegister />} />
            <Route exact path='/about' element={<About />} />
            <Route exact path='/shop' element={<Shop />} />
            <Route exact path='/cart' element={<CartDetails />} />
            <Route exact path='/order/success' element={<OrderSuccess />} />
            <Route exact path='/order/failed' element={<OrderFailed />} />
            <Route exact path='/checkout' element={<Checkout />} />
            <Route exact path='/contact' element={<ContactUs />} />
            <Route exact path='/termsAndCondition' element={<TermsAndConditions />} />
            <Route exact path='/privacyPolicy' element={<PrivacyPolicy />} />
            <Route exact path='/cancellationsAndRefunds' element={<CancellationsAndRefunds />} />
            <Route exact path='/shipping' element={<Shipping />} />
            <Route exact path='/blog' element={<BlogList />} />
            <Route exact path='/profile' element={<MyAccount />} />
            <Route exact path='/product/:id' element={<ProductDetails />} />
            <Route exact path='/blog/:id' element={<BlogDetails />} />
            {user && user?.isAdmin && (
              <>
                <Route exact path='/admin/orders' element={<OrderManagement />} />
                <Route exact path='/admin/order/details/:id' element={<UpdateOrderDetails />} />
                <Route exact path='/admin/blogs' element={<ManageBlogs />} />
                <Route exact path='/admin/pincodes' element={<ManagePincodes />} />
              </>
            )}
            {user && user?.isSuperAdmin && (
              <>
                <Route exact path='/super_admin/products' element={<ManageProducts />} />
              </>
            )}
            <Route path='/*' element={<Navigate replace to='/' />} />
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>

      <Tooltip title='Message us for customized cakes.' arrow>
        <a
          href='https://wa.me/919945423080'
          // className={`scroll-top ${isVisible ? 'show' : ''}`}
          className={`scroll-top show`}
          id='scroll-top'
          target='_blank'
          // onClick={scrollToTop}
        >
          <i className='lastudioicon-b-whatsapp' style={{ fontSize: '1.4rem', marginTop: -1 }}></i>
        </a>
      </Tooltip>
    </>
  );
};

export default App;
